// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1tn9q","content":"styles_content__2Uvup"};